import { PrivacyEventPhotography } from './PrivacyEventPhotography';

export default PrivacyEventPhotography;
